export const getAreaInfo = (data) => {
  const mapping = {};
  const items = [];
  data.forEach((v) => {
    const { level } = v;
    const areaCode = v.area_code || v.code;
    const name = v.area_name || v.name;
    const parentCode = v.parent_code || v.parentCode;
    if (!mapping[areaCode]) {
      mapping[areaCode] = {
        value: areaCode,
        desc: name,
      };
      if (level === 1) {
        mapping[areaCode].parent_id = parentCode;
      }
    }
    if (level === 0) {
      if (!mapping[areaCode].options) {
        mapping[areaCode].options = [];
      }
      items.push(mapping[areaCode]);
    } else if (level === 1) {
      if (mapping[parentCode]) {
        mapping[parentCode].options.push(mapping[areaCode]);
      } else {
        mapping[parentCode].options = [mapping[areaCode]];
      }
    }
  });

  const withoutChilren = {};
  Object.keys(mapping).forEach((v) => {
    const { value, desc, parent_id: parentId } = mapping[v];
    withoutChilren[v] = { value, desc };
    if (parentId) {
      withoutChilren[v].parent_id = parentId;
    }
  });

  return { map: withoutChilren, items };
};
